import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef,
} from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import {
  FaSearch,
  FaPlus,
  FaSort,
  FaChevronDown,
  FaFilter,
  FaStore,
  FaUser,
  FaEllipsisH,
} from "react-icons/fa";
import Button from "../../../components/MaterialButton";
import Input from "../../../components/MaterialInput";
import Card from "../../../components/MaterialCard";
import { BASE_URL } from "utils/constant";
import VendorShopManagement from "./Vendor/VendorShopManagement";
import InventoryItemDetails from "./Inventory/InventoryItemDetails";
import NewMaterialForm from "./Inventory/NewMaterialForm";
import DeliveryCard from "./Delivery/DeliveryCard";
import VendorProfile from "./Vendor/VendorProfile";
import DeliveryStatusFilter from "./Delivery/DeliveryStatusFilter";
import MaterialPurchaseForm from "../Finance/MaterialPurchaseForm";
import NewVendorModal from "./Vendor/NewVendor";
import materialIcons from "utils/materialIcons";
import { GoArrowSwitch } from "react-icons/go";
import { useAlert } from "components/UI_components/Alert";
import { display } from "@mui/system";
import PermissionEmptyState from "components/UI_components/EmptyStateFinance";
import DeliverySortFilter from "./Delivery/DeliverySortFilter";
import InventorySortFilter from "./Inventory/InventorySortFilter";
import { Link, Loader, Search, Clock, CheckCheck, XCircle } from "lucide-react";
import { json } from "utils/http/client";
import EmptyIcon from "assets/empty state/NoData.svg";
import MaterialCreateForm from "./Inventory/MultiCreateMaterialForm";
import NewMaterialRequest from "./MaterialRequest/NewRequest";
import MaterialRequestSidebar from "./MaterialRequest/MaterialRequestSidebar";
import DeliveryDetails from "./Delivery/DeliveryDetails";
import { SiDatabricks } from "react-icons/si";
import LoadingScreen from "components/UI_components/LoadingScreen";
import StockUpdateForm from "./Inventory/StockUpdateforTask";
import { getLinkedTasksBySite } from "utils/linkedTasks";
import { TbTruckDelivery } from "react-icons/tb";
import { MdOutlineInventory2 } from "react-icons/md";
import { BiGitPullRequest } from "react-icons/bi";
import {
  Tabs,
  TabsList,
  TabsTrigger,
} from "../../../components/ui-custom/Tabs";

const TABS = [
  { id: "inventory", label: "inventory", icon: MdOutlineInventory2 },
  {
    id: "purchases-deliveries",
    label: "Purchases & Deliveries",
    icon: TbTruckDelivery,
  },
  {
    id: "material-requests",
    label: "material Requests",
    icon: BiGitPullRequest,
  },
];

const REQUEST_TABS = [
  { label: "Pending", value: ["PENDING_APPROVAL"], icon: Clock },
  {
    label: "Approved",
    icon: CheckCheck,
    value: ["OPEN", "SENT", "COMPLETED", "PARTIAL_DELIVERY", "RETURN", "DRAFT"],
  },
  { label: "Rejected", value: ["REJECTED"], icon: XCircle },
];

const InventoryTable = ({ paginatedItems, handleItemClick, onUpdateClick }) => (
  <div className="w-full overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm mb-2">
    <div className="overflow-x-auto">
      <table className="w-full text-left border-collapse table-auto">
        <thead className="bg-[#F9FAFB] border-b border-gray-200">
          <tr>
            <th className="px-3 py-3 text-xs font-bold text-gray-500 uppercase tracking-wider text-center">
              Material
            </th>
            <th className="px-3 py-3 text-xs font-bold text-gray-500 uppercase">
              Specification
            </th>
            <th className="px-3 py-3 text-xs font-bold text-gray-500 uppercase">
              Brand Name
            </th>
            <th className="px-3 py-3 text-xs font-bold text-gray-500 uppercase tracking-wider text-right">
              Current Stock
            </th>
            <th className="px-3 py-3 text-xs font-bold text-gray-500 uppercase tracking-wider text-right">
              Previous Stock
            </th>
            <th className="px-3 py-3 text-xs font-bold text-gray-500 uppercase tracking-wider">
              Last Updated
            </th>
            <th className="px-3 py-3 text-xs font-bold text-gray-500 uppercase tracking-wider text-center">
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {paginatedItems.map((item, index) => (
            <tr
              key={item.id || index}
              className="hover:bg-gray-50 transition-colors cursor-pointer group"
              onClick={() => handleItemClick(item)}
            >
              <td className="px-3 py-4">
                <div className="flex items-center gap-3">
                  {materialIcons[item.material_name?.toLowerCase()] ? (
                    <img
                      src={materialIcons[item.material_name.toLowerCase()]}
                      alt={item.material_name}
                      className="w-10 h-10 rounded-full object-cover border border-gray-100 shadow-sm"
                    />
                  ) : (
                    <div className="w-10 h-10 rounded-full flex items-center justify-center bg-purple-50 border border-purple-100">
                      <SiDatabricks className="text-sm-primary" size={20} />
                    </div>
                  )}
                  <div className="flex flex-col min-w-0">
                    <span className="font-semibold text-gray-900 truncate">
                      {item.material_name}
                    </span>
                    <span className="text-xs text-gray-500 truncate">
                      {item.subcategory}
                    </span>
                  </div>
                </div>
              </td>
              <td className="px-3 py-4 text-sm text-gray-600">
                {item.specification || "—"}
              </td>
              <td className="px-3 py-4 text-sm text-gray-600">
                {item.brand_name || item.brand || "—"}
              </td>
              <td className="px-3 py-4 text-right">
                <span className="text-sm font-bold text-gray-900">
                  {item.current_stock} {item.uom}
                </span>
              </td>
              <td className="px-3 py-4 text-right">
                <span
                  className={`text-sm font-semibold ${item.last_stock > 0 ? "text-green-500" : item.last_stock < 0 ? "text-red-500" : "text-gray-600"}`}
                >
                  {item.last_stock !== null && item.last_stock !== undefined
                    ? `${item.last_stock > 0 ? "+" : ""}${item.last_stock} ${item.uom}`
                    : "—"}
                </span>
              </td>
              <td className="px-3 py-4">
                <div className="flex flex-col min-w-0">
                  <span className="text-sm text-gray-500 truncate">
                    {item.last_updated_by}
                  </span>
                  <span className="text-xs text-gray-700">
                    {formatDate(item.last_updated_on)}
                  </span>
                </div>
              </td>
              <td className="px-3 py-4 text-center">
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onUpdateClick(item);
                  }}
                  className="bg-[#ECE6F0] text-[#3B0069] font-bold px-4 py-2 rounded-lg flex flex-row items-center gap-2 justify-center hover:bg-[#DED2E9] text-sm transition-all border border-[#C5B3D2] shadow-sm mx-auto"
                >
                  Update
                  <div className="rounded-full bg-[#C5B3D2] p-1 group-hover:bg-[#B399C6] transition-colors">
                    <GoArrowSwitch size={12} fill="#3B0069" />
                  </div>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

const VendorItem = ({ vendor, onClick }) => (
  <div
    className="w-full p-4 mb-2 bg-white rounded-lg shadow-sm border border-gray-200 cursor-pointer hover:bg-gray-50"
    onClick={() => onClick?.(vendor)}
  >
    <div className="flex items-center pb-2 border-b border-gray-200">
      <div className="p-2 bg-gray-100 rounded-full mr-3">
        {vendor.vendor_type === "Shop" ? (
          <FaStore size={28} className="text-purple-700" />
        ) : (
          <FaUser size={28} className="text-purple-700" />
        )}
      </div>

      <div className="flex-grow">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-2">
            <h3 className="text-base font-semibold">{vendor.name}</h3>
            <span className="bg-gray-100 px-2 py-0.5 rounded-full text-xs font-medium text-gray-600">
              {vendor.vendor_type}
            </span>
          </div>
          <button className="hover:bg-gray-100 p-1 rounded-full">
            <FaEllipsisH size={20} className="text-gray-700" />
          </button>
        </div>
        <p className="text-sm font-medium text-gray-600 mt-0.5">
          +91- {vendor.contact_no}
        </p>
      </div>
    </div>

    <div className="flex justify-between items-center mt-2">
      <div>
        <p className="text-xs font-medium text-gray-600">
          Last Purchase/Delivery
        </p>
        <p className="text-xs text-gray-600">
          {formatDate(vendor.last_updated_on)}
        </p>
      </div>
      <div>
        <p className="text-xs font-medium text-gray-600">Upcoming Delivery</p>
        <p className="text-xs text-gray-600">
          {formatDate(vendor.last_updated_on)}
        </p>
      </div>
    </div>
  </div>
);

const MaterialRequestItem = ({ request, onClick, activeRequestTab }) => (
  <div
    className="w-full px-3 py-2 mb-2 bg-white grid grid-cols-[1.2fr_2fr_1.6fr_1.6fr_auto] gap-4 items-center rounded-lg shadow-sm border-[1px] border-[#CCCCCC] cursor-pointer hover:bg-gray-50"
    onClick={() => onClick(request)}
  >
    <div className="flex flex-row items-center text-[#232323] font-normal">
      {request.mr_number}
    </div>
    <div className="flex flex-col items-start">
      <div className="text-[#737373] text-sm">Content</div>
      <div>
        {request.material_request_lines[0]?.material_name}
        {request.material_request_lines.length > 1
          ? ` + ${request.material_request_lines.length - 1} items`
          : ""}
      </div>
    </div>
    <div className="flex flex-col items-start">
      <div className="flex items-center gap-1 whitespace-nowrap">
        <span className="text-[#737373] text-sm">
          {activeRequestTab === "Pending" ? "Created by" : "Approved by"}
        </span>
        <span>{request.last_updated_by || "N/A"}</span>
      </div>

      <div>
        <span className="text-[#737373] text-sm">On </span>
        {activeRequestTab === "Pending"
          ? formatDMY(request.created_on)
          : formatDMY(request.last_updated_on)}
      </div>
    </div>
    <div className="flex flex-col items-start">
      <div className="text-[#737373] text-sm">Delivery expected by</div>
      <div>
        {request.due_date
          ? new Date(request.due_date).toLocaleDateString("en-US", {
              day: "numeric",
              month: "short",
              year: "numeric",
            })
          : "N/A"}
      </div>
    </div>
    <button
      onClick={() => onClick(request)}
      className="flex flex-row items-center justify-center text-sm text-[#3B0069] font-medium px-6 py-1 hover:bg-purple-50 rounded-md border-[1px] border-[#3B0069]"
    >
      View
    </button>
  </div>
);

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const formattedDate = date.toLocaleDateString("en-US", {
    day: "numeric",
    month: "short",
  });
  const formattedTime = date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
  return `${formattedDate} ${formattedTime}`;
};

const formatDMY = (dateString) => {
  if (!dateString) return "N/A";
  const d = new Date(dateString);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
};

const BulkStockUpdateModal = ({ materials, onClose, onSuccess }) => {
  const alert = useAlert();
  const [stockAction, setStockAction] = useState("");
  const [selectedMaterialIds, setSelectedMaterialIds] = useState([]);
  const [quantities, setQuantities] = useState({});
  const [boqItems, setBoqItems] = useState([]);
  const [selectedTasks, setSelectedTasks] = useState({});
  const [taskPickerMaterialId, setTaskPickerMaterialId] = useState(null);
  const [taskSearchQuery, setTaskSearchQuery] = useState("");
  const [materialSearchQuery, setMaterialSearchQuery] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const today = useMemo(() => new Date().toISOString().split("T")[0], []);
  const [updateDate, setUpdateDate] = useState(today);
  const selectAllRef = useRef(null);
  const getNormalizedTaskStatus = (item) =>
    String(
      item?.task_status ||
        item?.taskStatus ||
        item?.status ||
        item?.task_details?.task_status ||
        item?.task_details?.status ||
        "",
    ).toLowerCase();

  const isCompletedTask = (item) =>
    getNormalizedTaskStatus(item).includes("complete");

  const filteredBoqItems = boqItems.filter(
    (item) =>
      !isCompletedTask(item) &&
      `${item.task_name || item.item_name || ""} ${item.sectionName || ""}`
        .toLowerCase()
        .includes(taskSearchQuery.toLowerCase()),
  );
  const getTaskStatusBucket = (item) => {
    const normalizedStatus = getNormalizedTaskStatus(item);

    if (
      normalizedStatus.includes("halt") ||
      normalizedStatus.includes("hold") ||
      normalizedStatus.includes("pause")
    ) {
      return "halted";
    }
    if (
      normalizedStatus.includes("not started") ||
      normalizedStatus.includes("not_started")
    ) {
      return "notStarted";
    }
    if (
      normalizedStatus.includes("ongoing") ||
      normalizedStatus.includes("in progress") ||
      normalizedStatus.includes("in_progress")
    ) {
      return "ongoing";
    }
    return "notStarted";
  };

  const groupedBoqItems = [
    { key: "ongoing", title: "Ongoing" },
    { key: "notStarted", title: "Not Started" },
    { key: "halted", title: "Halted" },
  ]
    .map((group) => ({
      ...group,
      items: filteredBoqItems.filter(
        (item) => getTaskStatusBucket(item) === group.key,
      ),
    }))
    .filter((group) => group.items.length > 0);
  const normalizedMaterialSearchQuery = materialSearchQuery
    .trim()
    .toLowerCase();
  const filteredMaterials = useMemo(
    () =>
      materials.filter((material) =>
        [
          material.material_name,
          material.subcategory,
          material.specification,
          material.brand_name,
          material.brand,
          material.uom,
        ]
          .filter(Boolean)
          .join(" ")
          .toLowerCase()
          .includes(normalizedMaterialSearchQuery),
      ),
    [materials, normalizedMaterialSearchQuery],
  );
  const filteredMaterialIds = filteredMaterials.map((material) => material.id);
  const selectedFilteredCount = filteredMaterialIds.filter((materialId) =>
    selectedMaterialIds.includes(materialId),
  ).length;
  const areAllFilteredSelected =
    filteredMaterialIds.length > 0 &&
    selectedFilteredCount === filteredMaterialIds.length;

  useEffect(() => {
    const fetchLinkedTasks = async () => {
      try {
        const linkedTasks = await getLinkedTasksBySite();
        setBoqItems(linkedTasks);
      } catch (error) {
        console.error("Error fetching linked tasks:", error);
      }
    };

    fetchLinkedTasks();
  }, []);

  useEffect(() => {
    if (!selectAllRef.current) return;

    selectAllRef.current.indeterminate =
      selectedFilteredCount > 0 && !areAllFilteredSelected;
  }, [selectedFilteredCount, areAllFilteredSelected]);

  const toggleMaterial = (materialId) => {
    setSelectedMaterialIds((current) =>
      current.includes(materialId)
        ? current.filter((id) => id !== materialId)
        : [...current, materialId],
    );
  };

  const toggleSelectAllMaterials = () => {
    setSelectedMaterialIds((current) => {
      if (areAllFilteredSelected) {
        return current.filter((id) => !filteredMaterialIds.includes(id));
      }

      return Array.from(new Set([...current, ...filteredMaterialIds]));
    });
  };

  const handleQuantityChange = (materialId, value) => {
    if (value === "" || Number(value) >= 0) {
      setQuantities((current) => ({
        ...current,
        [materialId]: value,
      }));
    }
  };

  const getMaterialQuantity = (materialId) => quantities[materialId] || "";

  const openTaskPicker = (materialId) => {
    setTaskPickerMaterialId(materialId);
    setTaskSearchQuery("");
  };

  const closeTaskPicker = () => {
    setTaskPickerMaterialId(null);
    setTaskSearchQuery("");
  };

  const selectTaskForMaterial = (materialId, task) => {
    setSelectedTasks((current) => ({
      ...current,
      [materialId]: task,
    }));
    closeTaskPicker();
  };

  const removeTaskForMaterial = (materialId) => {
    setSelectedTasks((current) => {
      const next = { ...current };
      delete next[materialId];
      return next;
    });
  };

  const getTaskIdFromSelection = (selectedTask) =>
    selectedTask?.task ||
    selectedTask?.task_id ||
    selectedTask?.taskId ||
    selectedTask?.task_details?.id ||
    selectedTask?.id ||
    null;

  const validateBulkUpdate = () => {
    if (!stockAction) {
      alert.addAlert("Please choose Added or Used", "error");
      return false;
    }

    if (selectedMaterialIds.length === 0) {
      alert.addAlert("Please select at least one material", "error");
      return false;
    }

    if (!updateDate) {
      alert.addAlert("Please select an update date", "error");
      return false;
    }

    const selectedMaterials = materials.filter((material) =>
      selectedMaterialIds.includes(material.id),
    );

    const hasInvalidQuantity = selectedMaterials.some((material) => {
      const quantity = Number(getMaterialQuantity(material.id));
      return !quantity || quantity <= 0;
    });

    if (hasInvalidQuantity) {
      alert.addAlert(
        "Please enter a valid quantity for every selected material",
        "error",
      );
      return false;
    }

    if (stockAction === "used") {
      const overusedMaterial = selectedMaterials.find(
        (material) =>
          Number(getMaterialQuantity(material.id)) >
          Number(material.current_stock || 0),
      );

      if (overusedMaterial) {
        alert.addAlert(
          `Cannot use more than available stock for ${overusedMaterial.material_name}`,
          "error",
        );
        return false;
      }

      const materialWithoutTask = selectedMaterials.find(
        (material) => !getTaskIdFromSelection(selectedTasks[material.id]),
      );

      if (materialWithoutTask) {
        alert.addAlert(
          `Please link a task for ${materialWithoutTask.material_name}`,
          "error",
        );
        return false;
      }
    }

    return true;
  };

  const handleSubmit = async () => {
    if (!validateBulkUpdate()) return;

    setIsSubmitting(true);

    try {
      const accessToken = localStorage.getItem("access");
      const selectedMaterials = materials.filter((material) =>
        selectedMaterialIds.includes(material.id),
      );

      const requests = selectedMaterials.map((material) => {
        const quantity = Number(getMaterialQuantity(material.id));
        const enteredQuantity = stockAction === "added" ? quantity : -quantity;

        return fetch(`${BASE_URL}/inventory/create-stock/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken.trim()}`,
          },
          body: JSON.stringify({
            update_date: updateDate,
            entered_quantity: enteredQuantity,
            comment: "",
            material: material.id,
            task_id:
              stockAction === "used"
                ? getTaskIdFromSelection(selectedTasks[material.id])
                : null,
          }),
        }).then(async (response) => {
          if (!response.ok) {
            let errorMessage = "Failed to update stock";

            try {
              const errorData = await response.json();
              errorMessage =
                errorData.message || errorData.error || errorMessage;
            } catch (error) {
              errorMessage = response.statusText || errorMessage;
            }

            throw new Error(`${material.material_name}: ${errorMessage}`);
          }

          return response.json();
        });
      });

      await Promise.all(requests);
      alert.addAlert("Bulk stock updated successfully", "success");
      onSuccess();
    } catch (error) {
      console.error("Bulk stock update error:", error);
      alert.addAlert(
        error.message || "Failed to update stock in bulk",
        "error",
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex bg-black bg-opacity-50"
      onClick={onClose}
    >
      <div
        className="ml-auto h-full w-full md:w-2/5 border-l border-gray-200 bg-[#FAFBFD] shadow-xl flex flex-col"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="sticky top-0 z-10 flex items-center justify-between px-6 py-4 border-b border-gray-200 bg-white">
          <div className="flex items-center gap-3">
            <div>
              <h2 className="text-xl font-semibold text-gray-900">
                Bulk Update Materials
              </h2>
              <p className="text-sm text-gray-500">
                Select materials and enter the quantity to add or use from
                stock.
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
            disabled={isSubmitting}
          >
            <span className="text-2xl leading-none">&times;</span>
          </button>
        </div>

        <div className="grid gap-3 border-b border-gray-100 px-6 py-4 bg-white">
          <div className="flex items-center gap-3 w-full md:max-w-[520px]">
            <button
              type="button"
              onClick={() =>
                setStockAction((current) =>
                  current === "added" ? "" : "added",
                )
              }
              className={`flex-1 min-w-0 rounded-lg border px-4 py-2 text-sm font-semibold transition shadow-sm ${
                stockAction === "added"
                  ? "border-green-500 bg-green-500 text-white"
                  : "border-green-200 bg-green-50 text-green-700 hover:bg-green-100"
              }`}
            >
              Add to inventory
            </button>
            <button
              type="button"
              onClick={() =>
                setStockAction((current) =>
                  current === "used" ? "" : "used",
                )
              }
              className={`flex-1 min-w-0 rounded-lg border px-4 py-2 text-sm font-semibold transition shadow-sm ${
                stockAction === "used"
                  ? "border-red-500 bg-red-500 text-white"
                  : "border-red-200 bg-red-50 text-red-700 hover:bg-red-100"
              }`}
            >
              Use from inventory
            </button>
          </div>

          <div className="flex flex-col w-full md:max-w-[260px]">
            <label className="mb-1 text-sm font-medium text-gray-700">
              Update date
            </label>
            <input
              type="date"
              value={updateDate}
              max={today}
              disabled={isSubmitting}
              onChange={(event) => setUpdateDate(event.target.value)}
              className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm outline-none transition focus:border-[#3B0069] focus:ring-2 focus:ring-[#3B0069]/10 disabled:bg-gray-100 disabled:text-gray-400"
            />
          </div>

          <div className="relative flex items-center">
            <Search
              className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
              size={16}
            />
            <input
              type="text"
              placeholder="Search materials"
              value={materialSearchQuery}
              onChange={(event) => setMaterialSearchQuery(event.target.value)}
              className="w-full rounded-lg border border-gray-300 bg-white py-2 pl-10 pr-4 text-sm outline-none transition focus:border-[#3B0069] focus:ring-2 focus:ring-[#3B0069]/10"
            />
          </div>

          <div className="flex items-center justify-between pt-1">
            <label className="inline-flex items-center gap-3 text-sm text-gray-700">
              <input
                ref={selectAllRef}
                type="checkbox"
                checked={areAllFilteredSelected}
                disabled={filteredMaterials.length === 0 || isSubmitting}
                onChange={toggleSelectAllMaterials}
                className="h-4 w-4 rounded border-gray-300"
                style={{
                  accentColor:
                    stockAction === "added"
                      ? "#16a34a"
                      : stockAction === "used"
                        ? "#dc2626"
                        : "#9ca3af",
                }}
              />
              <span className="font-medium whitespace-nowrap">
                Select all available material
              </span>
            </label>
            <span className="text-sm text-gray-500">
              {selectedMaterialIds.length} selected
            </span>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto px-6 py-3">
          <div className="space-y-3 pb-24">
            {materials.length === 0 ? (
              <div className="rounded-xl border border-dashed border-gray-300 bg-white p-8 text-center text-gray-500">
                No materials available to update.
              </div>
            ) : filteredMaterials.length === 0 ? (
              <div className="rounded-xl border border-dashed border-gray-300 bg-white p-8 text-center text-gray-500">
                No materials match your search.
              </div>
            ) : (
              filteredMaterials.map((material) => {
                const isSelected = selectedMaterialIds.includes(material.id);
                const quantity = getMaterialQuantity(material.id);
                const isOverStock =
                  stockAction === "used" &&
                  Number(quantity) > Number(material.current_stock || 0);

                return (
                  <div
                    key={material.id}
                    onClick={() => toggleMaterial(material.id)}
                    className={`rounded-xl border px-3.5 py-3.5 transition shadow-sm ${
                      isSelected
                        ? stockAction === "added"
                          ? "border-green-300 bg-green-50"
                          : stockAction === "used"
                            ? "border-red-300 bg-red-50"
                            : "border-gray-300 bg-gray-50"
                        : "border-gray-200 bg-white hover:border-gray-300"
                    }`}
                  >
                    <div className="grid grid-cols-[28px_minmax(0,1fr)_130px_auto] items-center gap-3">
                      <input
                        type="checkbox"
                        checked={isSelected}
                        onClick={(event) => event.stopPropagation()}
                        onChange={() => toggleMaterial(material.id)}
                        className="h-5 w-5 rounded border-gray-300"
                        style={{
                          accentColor:
                            stockAction === "added"
                              ? "#16a34a"
                              : stockAction === "used"
                                ? "#dc2626"
                                : "#9ca3af",
                        }}
                      />

                      <div className="min-w-0">
                        <p className="font-semibold text-gray-900 truncate">
                          {material.material_name}
                        </p>
                        <p className="text-sm text-gray-500 truncate">
                          {material.subcategory || "No subcategory"}
                        </p>
                        <div className="mt-0.25 flex flex-wrap gap-x-2 gap-y-0.5 text-xs text-gray-500">
                          <span className="truncate">
                            Spec: {material.specification || "—"}
                          </span>
                          <span className="truncate">
                            Brand:{" "}
                            {material.brand_name || material.brand || "—"}
                          </span>
                        </div>
                        <p className="text-xs text-gray-500">
                          In stock: {material.current_stock || 0} {material.uom}
                        </p>
                      </div>

                      <input
                        type="number"
                        min="0"
                        step="0.01"
                        value={quantity}
                        disabled={!isSelected || isSubmitting}
                        onClick={(event) => event.stopPropagation()}
                        onChange={(event) =>
                          handleQuantityChange(material.id, event.target.value)
                        }
                        placeholder="Qty"
                        className={`w-full rounded-lg border bg-white px-2 py-2 text-center text-sm font-semibold outline-none transition disabled:bg-gray-100 disabled:text-gray-400 ${
                          stockAction === "added"
                            ? "text-green-700 focus:border-green-500 focus:ring-2 focus:ring-green-500/10"
                            : "text-red-700 focus:border-red-500 focus:ring-2 focus:ring-red-500/10"
                        } ${isOverStock ? "border-red-400" : "border-gray-300"}`}
                      />

                      <span className="text-sm font-semibold text-gray-700 whitespace-nowrap">
                        {material.uom}
                      </span>
                    </div>

                    {isOverStock && (
                      <p className="mt-1 ml-8 text-xs text-red-500">
                        Available: {material.current_stock || 0} {material.uom}
                      </p>
                    )}

                    {stockAction === "used" && boqItems.length > 0 ? (
                      <div className="min-w-0 mt-2 ml-8">
                        <button
                          type="button"
                          disabled={!isSelected || isSubmitting}
                          onClick={(event) => {
                            event.stopPropagation();
                            openTaskPicker(material.id);
                          }}
                          className="flex w-full items-center justify-between gap-3 rounded-lg border border-dashed border-gray-300 bg-white px-3 py-2 text-left text-sm transition hover:bg-gray-50 disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-400"
                        >
                          {selectedTasks[material.id] ? (
                            <span className="min-w-0">
                              <span className="block truncate font-medium text-[#3B0069]">
                                {selectedTasks[material.id].task_name ||
                                  selectedTasks[material.id].item_name}
                              </span>
                              <span className="block truncate text-xs text-gray-500">
                                {selectedTasks[material.id].sectionName}
                              </span>
                            </span>
                          ) : (
                            <span className="flex min-w-0 items-center text-gray-500">
                              <Link size={14} className="mr-2 shrink-0" />
                              <span className="truncate">Link to task</span>
                            </span>
                          )}
                          <span className="shrink-0 text-xs font-semibold text-[#3B0069]">
                            {selectedTasks[material.id] ? "Change" : "Link"}
                          </span>
                        </button>
                        {selectedTasks[material.id] && (
                          <button
                            type="button"
                            disabled={!isSelected || isSubmitting}
                            onClick={(event) => {
                              event.stopPropagation();
                              removeTaskForMaterial(material.id);
                            }}
                            className="mt-1 text-xs text-red-500 hover:text-red-700 disabled:cursor-not-allowed disabled:text-gray-400"
                          >
                            Remove link
                          </button>
                        )}
                      </div>
                    ) : null}
                  </div>
                );
              })
            )}
          </div>
        </div>

        <div className="sticky bottom-0 flex items-center justify-between gap-3 border-t border-gray-200 px-6 py-4 bg-white">
          <span className="text-sm text-gray-500">
            {selectedMaterialIds.length} material
            {selectedMaterialIds.length === 1 ? "" : "s"} selected
          </span>
          <div className="flex items-center gap-3">
            <button
              type="button"
              onClick={onClose}
              disabled={isSubmitting}
              className="rounded-lg bg-gray-100 px-6 py-2.5 text-sm font-semibold text-gray-700 transition hover:bg-gray-200 disabled:opacity-50"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleSubmit}
              disabled={isSubmitting || selectedMaterialIds.length === 0}
              className="rounded-lg bg-[#3B0069] px-10 py-2.5 text-sm font-semibold text-white transition hover:bg-[#3B0069]/85 disabled:cursor-not-allowed disabled:opacity-50"
            >
              {isSubmitting ? "Saving..." : "Save"}
            </button>
          </div>
        </div>
      </div>
      {taskPickerMaterialId !== null && (
        <div
          className="absolute inset-0 z-[60] flex items-center justify-center bg-black/40 p-4"
          onClick={closeTaskPicker}
        >
          <div
            className="w-full max-w-2xl max-h-[80vh] border border-slate-200 rounded-xl bg-white shadow-2xl overflow-hidden"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="p-3 border-b flex justify-between items-center bg-slate-50">
              <h3 className="text-sm font-semibold text-gray-800">
                Select Task
              </h3>
              <button
                type="button"
                onClick={closeTaskPicker}
                className="text-gray-400 hover:text-gray-600"
              >
                <span className="text-xl leading-none">&times;</span>
              </button>
            </div>

            <div className="p-3 border-b bg-white">
              <div className="relative">
                <Search
                  className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
                  size={16}
                />
                <input
                  type="text"
                  placeholder="Search BoQ items or sections..."
                  value={taskSearchQuery}
                  onChange={(event) => setTaskSearchQuery(event.target.value)}
                  className="w-full pl-10 pr-4 py-2 bg-gray-100 border-none rounded-md focus:ring-2 focus:ring-purple-500 text-sm"
                  autoFocus
                />
              </div>
            </div>

            <div className="overflow-y-auto max-h-[55vh] p-2 bg-white">
              {groupedBoqItems.map((group) => (
                <div key={group.key} className="mb-2">
                  <p className="px-1 py-1 text-[11px] font-semibold uppercase tracking-wider text-gray-500">
                    {group.title}
                  </p>
                  {group.items.map((item) => (
                    <div
                      key={item.id}
                      onClick={() =>
                        selectTaskForMaterial(taskPickerMaterialId, item)
                      }
                      className={`p-3 rounded-md cursor-pointer mb-1 transition-colors ${
                        selectedTasks[taskPickerMaterialId]?.id === item.id
                          ? "bg-purple-50 border border-purple-200"
                          : "hover:bg-gray-50 border border-transparent"
                      }`}
                    >
                      <div className="text-sm font-medium text-gray-800">
                        {item.task_name || item.item_name}
                      </div>
                      <div className="text-xs text-gray-500 mt-0.5">
                        {item.sectionName}
                      </div>
                      <div className="mt-2 flex items-center justify-between">
                        <span className="text-[10px] bg-gray-100 px-2 py-0.5 rounded-full text-gray-600">
                          {item.quantity} {item.uom}
                        </span>
                        {selectedTasks[taskPickerMaterialId]?.id ===
                          item.id && (
                          <span className="text-[10px] text-purple-600 font-bold uppercase tracking-wider">
                            Selected
                          </span>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              ))}

              {filteredBoqItems.length === 0 && (
                <div className="py-8 text-center text-gray-500 text-sm">
                  No matching items found
                </div>
              )}
            </div>

            <div className="p-3 border-t bg-slate-50">
              <button
                type="button"
                onClick={closeTaskPicker}
                className="w-full py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors text-sm font-medium"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const Inventory = ({
  userPermissions,
  setTab,
  setDelivery,
  delivery,
  permissionsLoading,
}) => {
  const { id: pathId, siteId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const tabQueryMap = useMemo(
    () => ({
      inventory: "inventory",
      purchase: "Purchases & Deliveries",
      requests: "material Requests",
      vendors: "vendors",
      machineries: "machineries",
    }),
    [],
  );

  const reverseTabQueryMap = useMemo(
    () => ({
      inventory: "inventory",
      "Purchases & Deliveries": "purchase",
      "material Requests": "requests",
      vendors: "vendors",
      machineries: "machineries",
    }),
    [],
  );

  const getActiveTabFromUrl = useCallback(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get("activeTab");
    return tabQueryMap[tab] || "inventory";
  }, [location.search, tabQueryMap]);

  const [currentTab, setCurrentTab] = useState(getActiveTabFromUrl());
  const [inventoryItems, setInventoryItems] = useState(
    localStorage.getItem(`${siteId}-inventory`)
      ? JSON.parse(localStorage.getItem(`${siteId}-inventory`))
      : [],
  );
  const [deliveryItems, setDeliveryItems] = useState(
    localStorage.getItem(`${siteId}-deliveries`)
      ? JSON.parse(localStorage.getItem(`${siteId}-deliveries`))
      : [],
  );
  const [vendorItems, setVendorItems] = useState(
    localStorage.getItem(`${siteId}-vendors`)
      ? JSON.parse(localStorage.getItem(`${siteId}-vendors`))
      : [],
  );
  const [machineryItems, setMachineryItems] = useState(
    localStorage.getItem(`${siteId}-machineries`)
      ? JSON.parse(localStorage.getItem(`${siteId}-machineries`))
      : [],
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [deliveryFilter, setDeliveryFilter] = useState("all");
  const [activeDeliveryStatus, setActiveDeliveryStatus] = useState("Upcoming");
  const [filteredDeliveries, setFilteredDeliveries] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [showNewMaterialForm, setShowNewMaterialForm] = useState(false);
  const [showNewDeliveryForm, setShowNewDeliveryForm] = useState(false);
  const [showNewRequestForm, setShowNewRequestForm] = useState(false);
  const [editingRequest, setEditingRequest] = useState(null);
  const [materialRequests, setMaterialRequests] = useState(
    localStorage.getItem(`${siteId}-materialRequests`)
      ? JSON.parse(localStorage.getItem(`${siteId}-materialRequests`))
      : [],
  );
  const [filteredMaterialRequests, setFilteredMaterialRequests] = useState([]);
  const [showMaterialPurchaseDetails, setShowMaterialPurchaseDetails] =
    useState(false);
  const [selectedDelivery, setSelectedDelivery] = useState(null);
  const [isVendorModalOpen, setIsVendorModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [isDeletingRequest, setIsDeletingRequest] = useState(false);
  const [pendingCreatedRequestId, setPendingCreatedRequestId] = useState(null);
  // Default the material request tab to "Pending" so a page refresh always shows Pending
  const [activeRequestTab, setActiveRequestTab] = useState("Pending");
  const [materialRequestSortBy, setMaterialRequestSortBy] =
    useState("recently_added");
  const [isRequestSortOpen, setIsRequestSortOpen] = useState(false);
  const requestSortRef = useRef(null);
  const materialRequestSortOptions = [
    { label: "Recently Added", value: "recently_added" },
    { label: "Expected Delivery Date", value: "expected_delivery" },
  ];
  const [stockUpdateItem, setStockUpdateItem] = useState(null);
  const [showBulkStockUpdate, setShowBulkStockUpdate] = useState(false);

  useEffect(() => {
    if (currentTab !== "inventory") return;

    let isCancelled = false;

    const preloadTabCounts = async () => {
      try {
        const site = localStorage.getItem("site");
        if (!site) return;

        const [deliveriesResponse, requestsResponse] = await Promise.all([
          json(`${BASE_URL}/inventory/get-deliveries-of-a-site/`, {
            method: "POST",
            body: { sites: site },
          }),
          json(`${BASE_URL}/inventory/material-requests/site/${site}/`, {
            method: "GET",
            body: null,
          }),
        ]);

        if (isCancelled) return;

        if (deliveriesResponse && Array.isArray(deliveriesResponse.data)) {
          const sortedDeliveries = [...deliveriesResponse.data].sort((a, b) => {
            return new Date(b.date) - new Date(a.date);
          });

          setDeliveryItems(sortedDeliveries);
          localStorage.setItem(
            `${site}-deliveries`,
            JSON.stringify(sortedDeliveries),
          );

          const statusIdMap = {
            Upcoming: 1,
            Delivered: 2,
            Cancelled: 3,
          };
          const activeTransactionId =
            statusIdMap[activeDeliveryStatus] ?? statusIdMap.Upcoming;
          setFilteredDeliveries(
            sortedDeliveries.filter(
              (delivery) => delivery.transaction_id === activeTransactionId,
            ),
          );
        }

        if (requestsResponse && Array.isArray(requestsResponse.data)) {
          const sortedRequests = [...requestsResponse.data].sort(
            (a, b) => new Date(b.created_on) - new Date(a.created_on),
          );

          setMaterialRequests(sortedRequests);
          localStorage.setItem(
            `${site}-materialRequests`,
            JSON.stringify(sortedRequests),
          );
        }
      } catch (error) {
        console.error("Error preloading material tab counts:", error);
      }
    };

    preloadTabCounts();

    return () => {
      isCancelled = true;
    };
  }, [currentTab, activeDeliveryStatus]);

  const handleRequestClick = (request) => {
    setSelectedRequest(request);
  };

  const sortMaterialRequests = useCallback((requests, sortBy) => {
    const parseDate = (dateString, fallback = 0) => {
      const timestamp = new Date(dateString).getTime();
      return Number.isNaN(timestamp) ? fallback : timestamp;
    };

    if (sortBy === "expected_delivery") {
      return [...requests].sort((a, b) => {
        const dateA = a?.due_date
          ? parseDate(a.due_date, Number.POSITIVE_INFINITY)
          : Number.POSITIVE_INFINITY;
        const dateB = b?.due_date
          ? parseDate(b.due_date, Number.POSITIVE_INFINITY)
          : Number.POSITIVE_INFINITY;

        if (dateA !== dateB) {
          return dateA - dateB;
        }

        return parseDate(b?.created_on) - parseDate(a?.created_on);
      });
    }

    return [...requests].sort(
      (a, b) => parseDate(b?.created_on) - parseDate(a?.created_on),
    );
  }, []);

  const alert = useAlert();
  const fetchData = useCallback(async () => {
    if (currentTab === "inventory") {
      if (inventoryItems.length === 0) {
        setIsLoading(true);
      }
    }
    if (currentTab === "Purchases & Deliveries") {
      if (deliveryItems.length === 0) {
        setIsLoading(true);
      }
    }
    if (currentTab === "vendors") {
      if (vendorItems.length === 0) {
        setIsLoading(true);
      }
    }
    if (currentTab === "machineries") {
      if (machineryItems.length === 0) {
        setIsLoading(true);
      }
    }
    if (currentTab === "material Requests") {
      if (materialRequests.length === 0) {
        setIsLoading(true);
      }
    }

    try {
      const accessToken = localStorage.getItem("access");
      const site = localStorage.getItem("site");

      const endpoints = {
        inventory: "get-materials-of-a-site",
        "Purchases & Deliveries": "get-deliveries-of-a-site",
        vendors: "list-site-vendors",
        machineries: "get-machineries-of-a-site",
        "material Requests": `material-requests/site/${site}`,
      };

      const url = `${BASE_URL}/inventory/${endpoints[currentTab]}/`;

      // const response = await fetch(url, {
      //   method: "POST",
      //   headers: {
      //     "Content-Type": "application/json",
      //     Authorization: `Bearer ${accessToken.trim()}`,
      //   },
      //   body: JSON.stringify({ sites: site }),
      // });

      // if (!response.ok) {
      //   throw new Error(`HTTP error! Status: ${response.status}`);
      // }

      // const data = await response.json();
      const data = await json(url, {
        method: currentTab === "material Requests" ? "GET" : "POST",
        body: currentTab === "material Requests" ? null : { sites: site },
      });

      if (data && Array.isArray(data.data)) {
        switch (currentTab) {
          case "inventory":
            // Default sort: newest first by last_updated_on
            const sortedInventory = [...data.data].sort((a, b) => {
              return new Date(b.last_updated_on) - new Date(a.last_updated_on);
            });
            setInventoryItems(sortedInventory);
            localStorage.setItem(
              `${site}-inventory`,
              JSON.stringify(sortedInventory),
            );
            break;
          case "Purchases & Deliveries":
            // Sort deliveries by date (most recent first)
            const sortedDeliveries = [...data.data].sort((a, b) => {
              return new Date(b.date) - new Date(a.date);
            });
            setDeliveryItems(sortedDeliveries);
            localStorage.setItem(
              `${site}-deliveries`,
              JSON.stringify(sortedDeliveries),
            );
            // Keep filtered list aligned with the selected delivery status tab
            const statusIdMap = {
              Upcoming: 1,
              Delivered: 2,
              Cancelled: 3,
            };
            const activeTransactionId =
              statusIdMap[activeDeliveryStatus] ?? statusIdMap.Upcoming;
            setFilteredDeliveries(
              sortedDeliveries.filter(
                (d) => d.transaction_id === activeTransactionId,
              ),
            );
            break;
          case "vendors":
            setVendorItems(data.data);
            break;
          case "machineries":
            setMachineryItems(data.data);
            break;
          case "material Requests":
            const sortedRequests = [...data.data].sort(
              (a, b) => new Date(b.created_on) - new Date(a.created_on),
            );
            setMaterialRequests(sortedRequests);
            localStorage.setItem(
              `${site}-materialRequests`,
              JSON.stringify(sortedRequests),
            );
            break;
        }
      }
    } catch (error) {
      console.error(`Error fetching ${currentTab} data:`, error);
    } finally {
      setIsLoading(false);
    }
  }, [currentTab, activeDeliveryStatus]);

  useEffect(() => {
    fetchData();
    setCurrentPage(1);
  }, [fetchData, currentTab]);

  // Sync tab with URL
  useEffect(() => {
    const tab = getActiveTabFromUrl();
    if (tab !== currentTab) {
      setCurrentTab(tab);
    }
  }, [getActiveTabFromUrl, currentTab]);

  // Handle deep linking to specific items
  useEffect(() => {
    if (pathId) {
      const accessToken = localStorage.getItem("access");
      const site = siteId || localStorage.getItem("site");
      const urlParams = new URLSearchParams(location.search);
      const activeTabParam = urlParams.get("activeTab");

      const fetchSpecificItem = async () => {
        setIsLoading(true);
        try {
          // If activeTab is purchase, try fetching as delivery first
          if (activeTabParam === "purchase") {
            const deliveryRes = await fetch(
              `${BASE_URL}/inventory/get-a-delivery/${pathId}/`,
              {
                headers: { Authorization: `Bearer ${accessToken}` },
              },
            );
            const deliveryData = await deliveryRes.json();
            if (deliveryData.status) {
              setSelectedDelivery(deliveryData.data);
              setShowMaterialPurchaseDetails(true);
              setCurrentTab("Purchases & Deliveries");
              return;
            }
          }

          // Try fetching as material
          const materialRes = await fetch(
            `${BASE_URL}/inventory/get-a-material/${pathId}/`,
            {
              headers: { Authorization: `Bearer ${accessToken}` },
            },
          );
          const materialData = await materialRes.json();
          if (materialData.status) {
            setSelectedItem(materialData.data);
            setCurrentTab("inventory");
            return;
          }

          // If not found as material and we haven't checked delivery yet, try delivery
          if (activeTabParam !== "purchase") {
            const deliveryRes = await fetch(
              `${BASE_URL}/inventory/get-a-delivery/${pathId}/`,
              {
                headers: { Authorization: `Bearer ${accessToken}` },
              },
            );
            const deliveryData = await deliveryRes.json();
            if (deliveryData.status) {
              setSelectedDelivery(deliveryData.data);
              setShowMaterialPurchaseDetails(true);
              setCurrentTab("Purchases & Deliveries");
              return;
            }
          }
        } catch (e) {
          console.error("Error fetching deep linked item:", e);
        } finally {
          setIsLoading(false);
        }
      };

      // Check if already in loaded lists with priority based on activeTab
      if (activeTabParam === "purchase") {
        const foundDelivery = deliveryItems.find(
          (d) => String(d.id) === pathId,
        );
        if (foundDelivery) {
          setSelectedDelivery(foundDelivery);
          setShowMaterialPurchaseDetails(true);
          setCurrentTab("Purchases & Deliveries");
          return;
        }
      }

      const foundItem = inventoryItems.find((i) => String(i.id) === pathId);
      if (foundItem) {
        setSelectedItem(foundItem);
        setCurrentTab("inventory");
        return;
      }

      if (activeTabParam !== "purchase") {
        const foundDelivery = deliveryItems.find(
          (d) => String(d.id) === pathId,
        );
        if (foundDelivery) {
          setSelectedDelivery(foundDelivery);
          setShowMaterialPurchaseDetails(true);
          setCurrentTab("Purchases & Deliveries");
          return;
        }
      }

      fetchSpecificItem();
    } else {
      setSelectedItem(null);
      setSelectedDelivery(null);
      setShowMaterialPurchaseDetails(false);
    }
  }, [pathId, siteId, inventoryItems, deliveryItems, location.search]);

  // Keep filtered material requests in sync with active tab and fetched data
  useEffect(() => {
    if (currentTab !== "material Requests") return;

    const activeTab = REQUEST_TABS.find((t) => t.label === activeRequestTab);
    if (!activeTab) {
      setFilteredMaterialRequests(
        sortMaterialRequests(materialRequests, materialRequestSortBy),
      );
      return;
    }

    const filteredAndSorted = sortMaterialRequests(
      materialRequests.filter((request) =>
        activeTab.value.includes(request.status),
      ),
      materialRequestSortBy,
    );

    setFilteredMaterialRequests(filteredAndSorted);
  }, [
    activeRequestTab,
    materialRequests,
    currentTab,
    materialRequestSortBy,
    sortMaterialRequests,
  ]);

  useEffect(() => {
    if (!isRequestSortOpen) return;

    const handleClickOutside = (event) => {
      if (
        requestSortRef.current &&
        !requestSortRef.current.contains(event.target)
      ) {
        setIsRequestSortOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isRequestSortOpen]);

  const handleFilterChange = useCallback((filteredItems, status) => {
    // Make sure we're sorting filtered deliveries by date too
    const sortedFilteredItems = [...filteredItems].sort((a, b) => {
      return new Date(b.date) - new Date(a.date);
    });
    setFilteredDeliveries(sortedFilteredItems);
    if (status) {
      setActiveDeliveryStatus(status);
    }
    setCurrentPage(1);
  }, []);

  // Add this useEffect to update totalPages whenever the current items list changes
  useEffect(() => {
    const currentItems = getCurrentItems();
    setTotalPages(Math.ceil(currentItems.length / itemsPerPage));
  }, [
    inventoryItems,
    filteredDeliveries,
    vendorItems,
    machineryItems,
    materialRequests,
    filteredMaterialRequests,
    currentTab,
    itemsPerPage,
  ]);

  const getCurrentItems = () => {
    let items = [];
    switch (currentTab) {
      case "inventory":
        items = inventoryItems;
        break;
      case "Purchases & Deliveries":
        items = filteredDeliveries;
        break;
      case "vendors":
        items = vendorItems;
        break;
      case "machineries":
        items = machineryItems;
        break;
      case "material Requests":
        items = filteredMaterialRequests;
        break;
      default:
        items = [];
    }

    // Apply search filter if searchTerm exists
    if (searchTerm) {
      items = items.filter((item) =>
        Object.values(item).some((value) =>
          String(value).toLowerCase().includes(searchTerm.toLowerCase()),
        ),
      );
    }

    return items;
  };

  const renderItems = () => {
    const items = getCurrentItems();
    const paginatedItems = paginateItems(items);
    // if (isLoading) {
    //   return (
    //     <div className="flex items-center justify-center h-full">
    //       <div className="loader">
    //         <Loader className="w-10 h-10 animate-spin text-purple-500" />
    //       </div>
    //     </div>
    //   );
    // }
    if (paginatedItems.length === 0) {
      return (
        // <div className="text-center py-8 text-gray-500">No items found</div>
        <div className="flex flex-col items-center justify-center py-6">
          <img src={EmptyIcon} alt="No tasks" className="mb-4" width={240} />
          <span className="text-gray-500 text-xl">No items found</span>
        </div>
      );
    }

    switch (currentTab) {
      case "inventory":
        return (
          <InventoryTable
            paginatedItems={paginatedItems}
            handleItemClick={handleItemClick}
            onUpdateClick={(item) => {
              if (
                !userPermissions?.edit_material_management &&
                !userPermissions?.edit_all &&
                !userPermissions?.is_admin
              ) {
                alert.addAlert(
                  "You don't have permission to update stock",
                  "error",
                );
                return;
              }
              setStockUpdateItem(item);
            }}
          />
        );
      case "Purchases & Deliveries":
        return paginatedItems.map((delivery) => (
          <DeliveryCard
            key={delivery.id}
            delivery={delivery}
            onClick={handleDeliveryClick}
          />
        ));
      case "vendors":
        return paginatedItems.map((vendor) => (
          <VendorItem
            key={vendor.id}
            vendor={vendor}
            onClick={handleVendorClick}
          />
        ));
      case "material Requests":
        return paginatedItems.map((request) => (
          <MaterialRequestItem
            key={request.id}
            request={request}
            onClick={handleRequestClick}
            activeRequestTab={activeRequestTab}
          />
        ));
      default:
        return null;
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  const handleItemClick = (item) => {
    navigate(`/site/${siteId}/materials/${item.id}?activeTab=inventory`);
  };

  const handleVendorClick = (vendor) => {
    setSelectedVendor(vendor);
  };

  const handleDeliveryClick = (delivery) => {
    navigate(`/site/${siteId}/materials/${delivery.id}?activeTab=purchase`);
  };

  useEffect(() => {
    if (delivery) {
      setSelectedDelivery(delivery);
      setShowMaterialPurchaseDetails(true);
    }
  }, [delivery]);

  useEffect(() => {
    if (!pendingCreatedRequestId) return;

    const createdRequest = materialRequests.find(
      (request) => String(request.id) === String(pendingCreatedRequestId),
    );
    if (!createdRequest) return;

    setSelectedRequest(createdRequest);
    setPendingCreatedRequestId(null);
  }, [materialRequests, pendingCreatedRequestId]);

  useEffect(() => {
    if (!selectedRequest?.id) return;

    const latestSelectedRequest = materialRequests.find(
      (request) => String(request.id) === String(selectedRequest.id),
    );

    if (latestSelectedRequest) {
      setSelectedRequest(latestSelectedRequest);
    }
  }, [materialRequests, selectedRequest?.id]);

  const refreshMaterialRequests = useCallback(async () => {
    const site = localStorage.getItem("site");
    const url = `${BASE_URL}/inventory/material-requests/site/${site}/`;
    const data = await json(url, { method: "GET", body: null });

    if (data && Array.isArray(data.data)) {
      const sortedRequests = [...data.data].sort(
        (a, b) => new Date(b.created_on) - new Date(a.created_on),
      );
      setMaterialRequests(sortedRequests);
      localStorage.setItem(
        `${site}-materialRequests`,
        JSON.stringify(sortedRequests),
      );
    }
  }, []);

  const handleEditMaterialRequest = () => {
    setEditingRequest(selectedRequest);
    setSelectedRequest(null);
    setShowNewRequestForm(true);
  };

  const handleDeleteMaterialRequest = async () => {
    if (!selectedRequest?.id || isDeletingRequest) return;

    try {
      setIsDeletingRequest(true);
      const response = await fetch(
        `${BASE_URL}/inventory/material-requests/${selectedRequest.id}/delete/`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        },
      );

      const data = await response.json().catch(() => null);

      if (!response.ok || data?.status === false || data?.success === false) {
        throw new Error(
          data?.message || data?.error || "Failed to delete material request",
        );
      }

      setSelectedRequest(null);
      await refreshMaterialRequests();
      alert.addAlert("Material request deleted successfully", "success");
    } catch (error) {
      alert.addAlert(
        error.message || "Failed to delete material request",
        "error",
      );
    } finally {
      setIsDeletingRequest(false);
    }
  };

  const handleMaterialRequestCreated = async (createdResponse) => {
    setCurrentTab("material Requests");
    setActiveRequestTab("Pending");
    setCurrentPage(1);
    setSelectedRequest(null);

    const createdId =
      createdResponse?.id ??
      createdResponse?.data?.id ??
      createdResponse?.data?.request?.id;

    if (createdId != null) {
      setPendingCreatedRequestId(String(createdId));
    }

    await refreshMaterialRequests();
  };

  const handleMaterialRequestUpdated = async (updatedResponse) => {
    setCurrentTab("material Requests");
    setActiveRequestTab("Pending");
    setCurrentPage(1);
    setEditingRequest(null);
    setSelectedRequest(null);

    const updatedId =
      updatedResponse?.id ??
      updatedResponse?.data?.id ??
      updatedResponse?.data?.request?.id ??
      editingRequest?.id;

    if (updatedId != null) {
      setPendingCreatedRequestId(String(updatedId));
    }

    await refreshMaterialRequests();
  };

  const paginateItems = (items) => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return items.slice(startIndex, endIndex);
  };

  const getTabCount = (tabLabel) => {
    switch (tabLabel) {
      case "inventory":
        return inventoryItems.length;
      case "Purchases & Deliveries":
        return deliveryItems.length;
      case "material Requests":
        return materialRequests.length;
      default:
        return 0;
    }
  };

  if (permissionsLoading) {
    return (
      <div className="flex items-center justify-center h-full">
        <Loader className="w-10 h-10 animate-spin text-purple-500" />
      </div>
    );
  }

  if (
    !userPermissions?.view_material_management &&
    !userPermissions?.is_admin &&
    !userPermissions?.view_all &&
    !permissionsLoading
  ) {
    return (
      <PermissionEmptyState
        module={"Material"}
        description={
          "You don't have permission to view material/inventory information for this site. Please contact your administrator for access. "
        }
      />
    );
  }

  const deliveryDetailsOverlay = showMaterialPurchaseDetails ? (
    <DeliveryDetails
      Delivery={selectedDelivery}
      onClose={() => {
        navigate(`/site/${siteId}/materials/?activeTab=purchase`);
      }}
      setTab={setTab} // ← ✱ forward unchanged
      setDelivery={setDelivery} // ← ✱ forward unchanged
      onMarkReceived={async () => {
        setActiveDeliveryStatus("Delivered");
        await fetchData();
        navigate(`/site/${siteId}/materials/?activeTab=purchase`);
      }}
      onMarkReturned={async () => {
        setActiveDeliveryStatus("Cancelled");
        await fetchData();
        navigate(`/site/${siteId}/materials/?activeTab=purchase`);
      }}
      userPermissions={userPermissions}
    />
  ) : null;
  if (selectedItem) {
    return (
      <div className="w-full h-full flex flex-col">
        <InventoryItemDetails
          item={selectedItem}
          userPermissions={userPermissions}
          onMaterialDeleted={async () => {
            await fetchData();
          }}
          onBack={() => {
            navigate(`/site/${siteId}/materials/?activeTab=inventory`);
          }}
        />
      </div>
    );
  }

  if (selectedVendor) {
    return (
      <div className="bg-gray-100 w-full h-full flex flex-col p-4">
        <VendorProfile
          vendor={selectedVendor}
          userPermissions={userPermissions}
          onBack={() => setSelectedVendor(null)}
          setTab={setTab}
          setDelivery={setDelivery}
        />
      </div>
    );
  }

  if (showNewDeliveryForm) {
    return (
      <MaterialPurchaseForm
        onClose={() => {
          setShowNewDeliveryForm(false);
          fetchData();
        }}
        onSuccess={fetchData}
      />
    );
  }

  return (
    <LoadingScreen loading={isLoading}>
      <div className="w-full flex flex-col p-4">
        {/* <ul className="flex flex-row items-center gap-12 mb-4 border-b">
          {["inventory", "Purchases & Deliveries", "material Requests"].map(
            (tab) => (
              <li
                key={tab}
                className={`mr-8 cursor-pointer ${currentTab === tab ? "text-[16px] font-bold" : "text-[16px]"
                  }  pb-2 ${currentTab === tab ? "border-b-2 border-black" : ""}`}
                style={{
                  color: currentTab === tab ? "#232323" : "#718EBF",
                }}
                onClick={() => {
                  const queryTab = reverseTabQueryMap[tab];
                  navigate(`/site/${siteId}/materials/?activeTab=${queryTab}`);
                }}
              >
                {tab.charAt(0).toUpperCase() + tab.slice(1)}
              </li>
            ),
          )}
        </ul> */}
        <div className="flex items-center justify-between mb-4">
          <Tabs
            value={currentTab}
            onValueChange={(value) => {
              const queryTab = reverseTabQueryMap[value];
              navigate(`/site/${siteId}/materials/?activeTab=${queryTab}`);
            }}
          >
            <TabsList className="h-9 p-1">
              {TABS.map((tab) => {
                const Icon = tab.icon;
                return (
                  <TabsTrigger
                    key={tab.id}
                    value={tab.label}
                    className="h-7 text-sm px-4 gap-1.5"
                  >
                    <Icon className="h-3.5 w-3.5" />
                    {tab.label.charAt(0).toUpperCase() + tab.label.slice(1)} (
                    {getTabCount(tab.label)})
                  </TabsTrigger>
                );
              })}
            </TabsList>
          </Tabs>
        </div>
        {/* {currentTab === "Purchases & Deliveries" && (
          <div className="mb-0 flex justify-between items-center">
            <DeliveryStatusFilter
              deliveries={deliveryItems}
              onFilterChange={handleFilterChange}
              activeStatus={activeDeliveryStatus}
              onActiveStatusChange={setActiveDeliveryStatus}
            />
            <DeliverySortFilter
              deliveries={filteredDeliveries}
              onSortChange={(sortedDeliveries) => {
                setFilteredDeliveries(sortedDeliveries);
                setCurrentPage(1);
              }}
            />
          </div>
        )} */}
        {currentTab === "Purchases & Deliveries" && (
          <div className="mb-0 flex justify-between items-center">
            <DeliveryStatusFilter
              deliveries={deliveryItems}
              onFilterChange={handleFilterChange}
              activeStatus={activeDeliveryStatus}
              onActiveStatusChange={setActiveDeliveryStatus}
            />
          </div>
        )}

        {currentTab === "material Requests" && (
          <div className="mb-0 flex justify-start items-center px-3">
            <Tabs
              value={activeRequestTab}
              onValueChange={(value) => {
                setActiveRequestTab(value);
                setCurrentPage(1);
              }}
            >
              <TabsList className="h-9 p-1">
                {REQUEST_TABS.map((tab) => {
                  const Icon = tab.icon;
                  return (
                    <TabsTrigger
                      key={tab.label}
                      value={tab.label}
                      className={`h-7 text-sm px-4 gap-1.5 border-none ${activeRequestTab === tab.label ? "!bg-sm-primary !text-white !shadow-none" : "!text-[#737373]"}`}
                    >
                      <Icon className="h-3.5 w-3.5" />
                      {tab.label} (
                      {
                        materialRequests.filter((r) =>
                          tab.value.includes(r.status),
                        ).length
                      }
                      )
                    </TabsTrigger>
                  );
                })}
              </TabsList>
            </Tabs>
          </div>
        )}

        <div className="flex px-3 justify-end mt-2 items-center space-x-4 mb-3">
          <div className="flex items-center space-x-4">
            <Input
              type="text"
              placeholder="Search"
              value={searchTerm}
              onChange={handleSearch}
              className="h-7 text-sm"
              style={{
                display: `${
                  currentTab === "Purchases & Deliveries" ? "none" : "flex"
                }`,
              }}
              icon={<FaSearch className="text-gray-400" />}
            />
            {currentTab === "inventory" && (
              <>
                <button
                  type="button"
                  className="h-7 bg-gray-100 text-gray-700 text-sm font-medium px-4 rounded-md flex items-center space-x-2 hover:bg-gray-200"
                  onClick={() => {
                    if (
                      !userPermissions?.edit_material_management &&
                      !userPermissions?.edit_all &&
                      !userPermissions?.is_admin
                    ) {
                      alert.addAlert(
                        "You don't have permission to update stock",
                        "error",
                      );
                      return;
                    }

                    setShowBulkStockUpdate(true);
                  }}
                >
                  <GoArrowSwitch className="text-gray-600" />
                  <span>Bulk Update</span>
                </button>
                <InventorySortFilter
                  inventoryItems={inventoryItems}
                  onSortChange={(sortedItems) => {
                    setInventoryItems(sortedItems);
                    setCurrentPage(1);
                  }}
                />
              </>
            )}
            {currentTab === "material Requests" && (
              <div className="relative inline-block" ref={requestSortRef}>
                <button
                  className="h-7 bg-gray-100 text-gray-700 text-sm px-4 rounded-md flex items-center space-x-2 hover:bg-gray-200"
                  onClick={() => setIsRequestSortOpen((prev) => !prev)}
                >
                  <FaSort className="text-gray-600" />
                  <span>Sort</span>
                  <FaChevronDown
                    className={`text-gray-600 transition-transform ${
                      isRequestSortOpen ? "rotate-180" : ""
                    }`}
                  />
                </button>

                {isRequestSortOpen && (
                  <div className="absolute right-0 mt-2 w-56 bg-white rounded-md shadow-lg z-10 py-1 border border-gray-200">
                    {materialRequestSortOptions.map((option) => (
                      <button
                        key={option.value}
                        className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-100 ${
                          materialRequestSortBy === option.value
                            ? "bg-purple-50 text-purple-700 font-medium"
                            : "text-gray-700"
                        }`}
                        onClick={() => {
                          setMaterialRequestSortBy(option.value);
                          setCurrentPage(1);
                          setIsRequestSortOpen(false);
                        }}
                      >
                        {option.label}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            )}
            {currentTab !== "Purchases & Deliveries" && (
              <button
                className="h-7 flex items-center space-x-2 px-4 bg-[#3B0069] text-sm text-white rounded-lg"
                onClick={() => {
                  if (
                    !userPermissions?.edit_material_management &&
                    !userPermissions?.is_admin &&
                    !userPermissions?.edit_all
                  ) {
                    alert.addAlert(
                      "You don't have permission to add new material/inventory information for this site. Please contact your administrator for access.",
                      "error",
                    );
                    return;
                  }

                  if (currentTab === "inventory") {
                    setShowNewMaterialForm(true);
                  } else if (currentTab === "vendors") {
                    setIsVendorModalOpen(true);
                  } else if (currentTab === "material Requests") {
                    setEditingRequest(null);
                    setShowNewRequestForm(true);
                  }
                }}
              >
                <FaPlus />
                <span>
                  {currentTab === "inventory"
                    ? "New Material"
                    : currentTab === "vendors"
                      ? "New Vendor"
                      : currentTab === "material Requests"
                        ? "New Material Request"
                        : ""}
                </span>
              </button>
            )}
          </div>
        </div>

        <div
          className={`flex-col gap-2 rounded-lg px-2 ${currentTab === "inventory" ? "h-[65vh] py-0" : "h-[60vh] py-2"} `}
          style={{
            overflowY: "auto",
          }}
        >
          <Card>{renderItems()}</Card>
        </div>

        <div className="flex justify-between w-[75vw] items-center mt-2">
          <Button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className={`py-2 px-4 rounded-md ${
              currentPage === 1
                ? "bg-gray-300 cursor-not-allowed"
                : "bg-purple-500 text-white hover:bg-purple-600"
            }`}
          >
            Previous
          </Button>

          {/* CUSTOM ITEMS PER PAGE INPUT */}
          <div className="flex items-center space-x-2">
            <label className="text-sm text-gray-500">Items per page:</label>
            <select
              value={itemsPerPage}
              onChange={(e) => setItemsPerPage(Number(e.target.value))}
              className="border border-gray-300 rounded-lg p-1"
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
            </select>
          </div>

          <span className="text-gray-700">
            Page {currentPage} of {totalPages}
          </span>
          <Button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className={`py-2 px-4 rounded-md ${
              currentPage === totalPages
                ? "bg-gray-300 cursor-not-allowed"
                : "bg-purple-500 text-white hover:bg-purple-600"
            }`}
          >
            Next
          </Button>
        </div>

        {showNewMaterialForm && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <MaterialCreateForm
              onClose={() => {
                setShowNewMaterialForm(false);
                fetchData();
              }}
            />
          </div>
        )}

        {showNewRequestForm && (
          <NewMaterialRequest
            onClose={() => {
              setShowNewRequestForm(false);
              setEditingRequest(null);
            }}
            onCreateMR={handleMaterialRequestCreated}
            onUpdateMR={handleMaterialRequestUpdated}
            initialRequest={editingRequest}
          />
        )}
        {selectedRequest && (
          <MaterialRequestSidebar
            request={selectedRequest}
            onClose={() => setSelectedRequest(null)}
            onEditRequest={handleEditMaterialRequest}
            onDeleteRequest={handleDeleteMaterialRequest}
            isDeletingRequest={isDeletingRequest}
          />
        )}
        <NewVendorModal
          isOpen={isVendorModalOpen}
          onClose={() => {
            setIsVendorModalOpen(false);
            fetchData();
          }}
        />
      </div>
      {showBulkStockUpdate && (
        <BulkStockUpdateModal
          materials={inventoryItems}
          onClose={() => setShowBulkStockUpdate(false)}
          onSuccess={() => {
            setShowBulkStockUpdate(false);
            fetchData();
          }}
        />
      )}
      {stockUpdateItem && (
        <StockUpdateForm
          onClose={() => {
            setStockUpdateItem(null);
            fetchData();
          }}
          materialId={stockUpdateItem.id}
          currentStock={stockUpdateItem.current_stock}
          onStockUpdate={() => {
            setStockUpdateItem(null);
            fetchData();
          }}
          materialDetails={stockUpdateItem}
        />
      )}
      {deliveryDetailsOverlay}
    </LoadingScreen>
  );
};

export default Inventory;
